import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import {PwaUpdateNotice} from "./shared/pwa/PwaUpdateNotice";
import "./styles/tokens.css";
import "./styles/global.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode:"always",
      retry: false,
      refetchOnWindowFocus: false
    }
  }
});

const container = document.getElementById("root");
if (container === null) throw new Error("缺少 #root 挂载点");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      {import.meta.env.PROD&&<PwaUpdateNotice/>}
    </QueryClientProvider>
  </StrictMode>
);
